import React, { Component } from "react";
import { Circles, Tooltip } from "@culturehq/components";

import { errorService, t } from "app/utils";

const ErrorFallback = ({ error }) => (
  <div className="chq-error">
    <Tooltip tip={t(`An error has occurred: ${error.message}`)}>
      <Circles />
    </Tooltip>
  </div>
);

class ErrorBoundary extends Component {
  state = { error: null };

  componentDidCatch(error) {
    errorService.error(error);
    this.setState({ error });
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error !== null) {
      return <ErrorFallback error={error} />;
    }

    return children;
  }
}

export default ErrorBoundary;
